import { useMutation } from "@tanstack/react-query";
import { useNavigate } from "react-router-dom";
import API from "@/api";
import { IPasswordChangePayload } from "@/api/authentication";


function useChangePassword() {
  const navigate = useNavigate();
  const { mutate, isPending, error } = useMutation({
    mutationFn: async (payload: IPasswordChangePayload) => {
      return API.changePassword(payload);
    },
    onSuccess: () => navigate("/"),
  });

  return {
    changePassword: mutate,
    isPending,
    error
  };
}

export default useChangePassword;
